export default __webpack_public_path__ + "static/media/big-wave.2921474f9496e71b626a2de0034b43e3.jpg";